import React from 'react';
import EsperLogin from '../components/HomePage/EsperLogin';
import Layout from '../layout';
import messages from '../i18n/en';
class IndexPage extends React.Component<any, any> {
  state = {
    isBrowser: true,
  };

  render() {
    return (
      <Layout
        keywords={`Esper Login, Esper SignUp, Free MDM Trail, Free Devops Software`}
        description={
          'Login to your Esper account with your cloud endpoint name or sign up to see the most powerful Android mobility management platform.'
        }
        messages={messages}
        fullScreen={true}
        title={'See Esper In Action. Login to Esper.'}
        className="first-page"
        location={this.props.location}
      >
        <EsperLogin
          currentLanguage={messages?.locale}
          messages={messages}
          isDeveloper={true}
        />
      </Layout>
    );
  }
}

export default IndexPage;
